export default "__VITE_ASSET__bp2z129s__"